import Icon from '../components/Icon.vue'

Icon.register({
  'dice-d20': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M106.8 215.1L1.2 370.9C-1.9 375.9 1.3 382.4 7.1 383.1L215.4 405.2 106.8 215.1zM7.4 315.4L82.7 193.1 6.1 147.1C3.4 145.5 0 147.4 0 150.5V313.3C0 317.4 5.3 318.9 7.4 315.4zM18.3 423.6L212.7 511.3C217.9 513.7 224 509.8 224 504V438.3L20.4 416C16 415.5 14.2 421.6 18.3 423.6zM99.5 165.8L179.4 22.9C183.7 15.8 175.8 7.6 168.6 11.7L17.8 110.4C15.3 112 15.4 115.6 17.9 117.1L99.5 165.8zM240 176H349.2L253.6 7.6C250.5 2.5 245.3 0 240 0S229.5 2.5 226.4 7.6L130.8 176H240zM473.9 147.1L397.3 193.1 472.6 315.4C474.7 318.9 480 317.4 480 313.3V150.5C480 147.4 476.6 145.5 473.9 147.1zM380.5 165.8L462.1 117.1C464.6 115.6 464.7 112 462.2 110.3L311.4 11.7C304.2 7.6 296.3 15.8 300.6 22.9L380.5 165.8zM459.6 416L256 438.3V504C256 509.8 262.1 513.7 267.4 511.3L461.8 423.6C465.8 421.6 464 415.5 459.6 416zM373.3 215.1L264.6 405.2 472.9 383.1C478.7 382.4 481.9 375.9 478.8 370.9L373.3 215.1zM240 208H139.6L240 383.8 340.4 208H240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-d20.js
// module id = KRyd
// module chunks = 144